module.exports = __webpack_public_path__ + "static/media/nav-reports.30771c0c.svg";